import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5.01L5 21l7-3 7 3V3zm-2 15l-5-2.18L7 18V5h10v13z"
}), 'TurnedInNotSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TurnedInNotSharp.js
// module id = 6948
// module chunks = 2